<cei-app-shell-layout
  class="app-shell"
  [menuLinks]="adminMenuLinks"
  [interactionMode]="sidenavInteractionMode"
  [sidenavExpanded]="sidenavExpanded()"
  (sidenavExpandedChange)="sidenavExpanded.set($event)"
  [isMobileViewport]="isMobileViewport()"
  [contentAreaPadding]="isMobileViewport() ? '1rem' : '2rem'"
  [footerPlacement]="CEI_APP_TEMPLATE_FOOTER_PLACEMENT_CONTENT"
  toolbarBackgroundColor="#584098"
  logoUrl="assets/cei-admin-logo.svg"
  logoAlt="Painel Administrativo CEI"
  [logoHeight]="75"
>
  <div
    user-actions
    class="app-user-actions"
    (click)="$event.stopPropagation()"
  >
    <cei-toolbar-user-area
      class="admin-toolbar-user-area"
      [userName]="userLogin()"
      [fotoSourceUrl]="sessionContext.details()?.foto_url"
      [ariaExpanded]="menuAberto()"
      avatarLabel="Abrir menu de dados pessoais"
      (avatarClick)="togglePersonalMenu($event)"
    >
      <cei-personal-data-menu
        [open]="menuAberto()"
        [items]="personalMenuItems()"
        [autoLoad]="false"
        (itemClick)="onPersonalMenuItemClick($event)"
      ></cei-personal-data-menu>
    </cei-toolbar-user-area>
  </div>

  <router-outlet />
</cei-app-shell-layout>
